import { render, staticRenderFns } from "./MagazineCard.vue?vue&type=template&id=18b93aae&scoped=true&"
import script from "./MagazineCard.vue?vue&type=script&lang=js&"
export * from "./MagazineCard.vue?vue&type=script&lang=js&"
import style0 from "./MagazineCard.vue?vue&type=style&index=0&id=18b93aae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b93aae",
  null
  
)

export default component.exports